import React, { useState } from 'react';
import { MAX_VISIBLE_ITEMS } from './constants.js';
import { TableCard, DetailedContent, TableCell } from './styles.js';
import Button from '../../Button/Button.js';
import { Modal } from '../../Modal/Modal.js';
import Caption from '../../Text/Caption/Caption.js';
import '../../Text/DetailedSubheading/DetailedSubheading.js';
import '../../Text/OverlineLg/OverlineLg.js';
import '../../Text/OverlineMd/OverlineMd.js';
import '../../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../../Text/ParagraphMd/ParagraphMd.js';
import '../../Text/SectionHeading/SectionHeading.js';
import '../../Text/SectionSubheading/SectionSubheading.js';
import '../../Text/Title/Title.js';

const RowInfo = ({ data, columns, role }) => (React.createElement(React.Fragment, null, data.map(({ key, value }, index) => {
    const { name: columnName } = columns[index];
    return (React.createElement(TableCell, { key: key, role: role },
        React.createElement(Caption, { type: "default", bold: true, as: "div" }, columnName),
        React.createElement(ParagraphMd, { type: "default", as: "div" }, value)));
})));
const Card = ({ data, columns, rawRows, detailedContent, index, seeMoreInfoButtonText, seeMoreInfoModalTitleText, }) => {
    const [moreInfoState, setMoreInfoState] = useState(false);
    const unslicedRow = rawRows[index];
    const toggleMoreInfo = (state) => () => setMoreInfoState(state);
    return (React.createElement(React.Fragment, null,
        React.createElement(TableCard, null,
            React.createElement(RowInfo, { data: data, columns: columns }),
            (detailedContent || unslicedRow.data.length > MAX_VISIBLE_ITEMS) && (React.createElement(Button, { fixed: true, variation: "secondary", size: "medium", onClick: toggleMoreInfo(true) }, seeMoreInfoButtonText))),
        React.createElement(Modal, { title: seeMoreInfoModalTitleText, isOpen: moreInfoState, onClose: toggleMoreInfo(false), body: React.createElement("div", { role: "list" },
                React.createElement(RowInfo, { data: unslicedRow.data, columns: columns, role: "listitem" }),
                detailedContent && (React.createElement(DetailedContent, null, detailedContent.content))) })));
};

export { Card as default };
